import { useQuery } from '@tanstack/react-query';
import { taskStatusConfigsApi } from '@/lib/api';

export function useTaskStatusConfigs() {
  return useQuery({
    queryKey: ['taskStatusConfigs'],
    queryFn: () => taskStatusConfigsApi.list(),
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });
}
